// PDF document mapping
export const getPdfUrl = (documentName) => {
  const pdfMap = {
    'Security Awareness and Acceptable Use': '/doc/Security Awareness and Acceptable Use_iCompaas.pdf',
    'Employee Code of Conduct': '/doc/iCompaas _Code Of Conduct (1).pdf',
    'Employee Policies Acknowledgement': '/doc/iCompaas_Employee Acknowledgement of Policies Policy.pdf',
  };
  
  return pdfMap[documentName] || null;
};

// Typed signature styles
export const TYPED_SIGNATURE_STYLES = [
  {
    key: 'signature-cursive-1',
    label: 'Signature Cursive 1',
    fontFamily: '"Brush Script MT","Segoe Script","Lucida Handwriting",cursive',
    fontSize: 120,
  },
  {
    key: 'signature-cursive-2',
    label: 'Signature Cursive 2',
    fontFamily: '"Snell Roundhand","Apple Chancery","URW Chancery L",cursive',
    fontSize: 120,
  },
  {
    key: 'signature-cursive-3',
    label: 'Signature Cursive 3',
    fontFamily: '"Comic Sans MS","Bradley Hand","Segoe Script",cursive',
    fontSize: 120,
  },
  {
    key: 'signature-cursive-4',
    label: 'Signature Cursive 4',
    fontFamily: '"Lucida Handwriting","Segoe Script","Brush Script MT",cursive',
    fontSize: 120,
  },
  {
    key: 'signature-normal-1',
    label: 'Signature Normal 1',
    fontFamily: '"Arial","Helvetica",sans-serif',
    fontSize: 120,
  },
  {
    key: 'signature-normal-2',
    label: 'Signature Normal 2',
    fontFamily: '"Times New Roman","Georgia",serif',
    fontSize: 120,
  },
];

// text blocks configuration
export const REQUIRED_TEXT_BLOCKS = [
  {
    id: 'signer-name',
    label: 'Signer Name',
    type: 'text',
    placeholder: 'Signer full name',
    widthPct: 0.3,
    allowMultiplePlacements: false,
  },
  {
    id: 'sign-date',
    label: 'Signing Date',
    type: 'date',
    placeholder: 'Select signing date',
    widthPct: 0.22,
    allowMultiplePlacements: false,
    captureValuePerPlacement: false,
  },
  {
    id: 'signer-position',
    label: 'Signer Position',
    type: 'text',
    placeholder: 'Employee role / title',
    widthPct: 0.28,
    allowMultiplePlacements: false,
  },
];

// Signing instructions
export const SIGNATURE_INSTRUCTIONS = [
  {
    title: 'Review the PDF',
    description: 'Scroll through every page on the left and make sure any highlighted sections are complete before you sign.',
  },
  {
    title: 'Add signer details',
    description: 'Enter your full legal name and the signing date, then click the buttons to position them directly on the document.',
  },
  {
    title: 'Create your signature',
    description: 'Type your signature image. You can clear or replace it at any time.',
  },
  {
    title: 'Place & save',
    description: 'Use "Place Signature" to drop it on the page, review the placement, and click Save Document to lock in your updates.',
  },
  {
    title: 'Submission is final',
    description: "Remember: once you submit a signed document you can only view it in read-only mode-re-signing isn't available.",
  },
];

export const DEFAULT_SIGNATURE_WIDTH_PCT = 2;

export const STANDARD_PAGE_WIDTH_PT = 612;

export const EMBEDDED_TEXT_FONT_SIZE = 12;
